/**
 * Box shadow value for components to appear above the rest of the page.
 *
 * @example
 * const Tooltip = styled.div`
 *   box-shadow: ${elevation.level2};
 *   ...
 * `
 */
const elevation = {
  /** Used for: IconButtons and similar elements */
  level1: "0px 2px 4px 0px rgba(0, 0, 0, 0.08), 0px 1px 3px 0px rgba(0, 0, 0, 0.08), 0px 1px 2px 0px rgba(0, 0, 0, 0.06)",
  /** Used for: Tooltips and similar elements */
  level2: "0px 4px 8px 0px rgba(0, 0, 0, 0.08), 0px 2px 4px 0px rgba(0, 0, 0, 0.08), 0px 1px 2px 0px rgba(0, 0, 0, 0.06)",
  /** Used for: Popovers and similar elements */
  level3: "0px 8px 16px 0px rgba(0, 0, 0, 0.08), 0px 4px 8px 0px rgba(0, 0, 0, 0.08), 0px 1px 2px 0px rgba(0, 0, 0, 0.06)",
  /** Used for: Modals and similar elements */
  level4: "0px 16px 32px 0px rgba(0, 0, 0, 0.08), 0px 8px 16px 0px rgba(0, 0, 0, 0.08), 0px 1px 2px 0px rgba(0, 0, 0, 0.06)"
};

export { elevation };
//# sourceMappingURL=elevation.js.map
